(function () {
  if (window.__bglInit) return;
  window.__bglInit = true;

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState === 'interactive' || document.readyState === 'complete') init();

  function init() {
    var data = window.BGL_DATA;
    if (!data) return;

    // Each section renders its own .bgl-page wrapper, so scope to the
    // whole document rather than the first one found.
    var root = document;

    var state = {
      size: 'medium',
      plan: 'starter',
      mode: 'sub',
      slide: 0,
      addons: { treats: false, balm: false, omega: false },
      faq: 0
    };

    var money = function (n) { return '$' + n.toFixed(2); };
    var label = function (n) { return n + (n === 1 ? ' jar' : ' jars'); };

    // --- header cart icon: hidden until the cart has items ---
    function updateCartBadge() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        root.querySelectorAll('[data-cart-link]').forEach(function (el) {
          el.classList.toggle('has-items', cart.item_count > 0);
          var countEl = el.querySelector('[data-cart-count]');
          if (countEl) countEl.textContent = cart.item_count;
        });
      }).catch(function () {});
    }
    updateCartBadge();

    function currentSize() { return state.size ? data.sizes[state.size] : null; }

    function activeTier() {
      var sz = currentSize();
      if (!sz) return null;
      return (state.plan === 'single' && sz.rec.jars > 1) ? sz.single : sz.rec;
    }

    function tierPrice(tier) {
      if (state.mode === 'sub' && tier.subPrice != null) return tier.subPrice;
      return tier.price;
    }

    function addonTotal() {
      var total = 0;
      Object.keys(state.addons).forEach(function (k) {
        if (state.addons[k] && data.addons[k]) total += data.addons[k].price;
      });
      return total;
    }

    function addonCount() {
      return Object.keys(state.addons).filter(function (k) { return state.addons[k]; }).length;
    }

    function setText(sel, val) {
      root.querySelectorAll('[data-bgl="' + sel + '"]').forEach(function (el) { el.textContent = val; });
    }
    function show(sel, on) {
      root.querySelectorAll('[data-bgl-if="' + sel + '"]').forEach(function (el) {
        el.classList.toggle('is-hidden', !on);
      });
    }

    function render() {
      var sz = currentSize();

      // size buttons
      root.querySelectorAll('.bgl-size-btn').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.getAttribute('data-size') === state.size);
      });

      show('size-picked', !!sz);
      show('size-unpicked', !sz);
      var addToCartBtn = root.querySelector('[data-add-to-cart]');
      if (addToCartBtn) addToCartBtn.disabled = !sz;

      if (!sz) {
        renderGallery(null);
        return;
      }

      var tier = activeTier();
      var single = sz.single;
      var isSub = state.mode === 'sub';

      // opt-out (single jar) visibility
      show('opt-out', sz.rec.jars > 1);
      var isSingleSelected = state.plan === 'single' && sz.rec.jars > 1;

      root.querySelectorAll('.bgl-plan[data-plan="starter"]').forEach(function (el) {
        el.classList.toggle('is-selected', !isSingleSelected);
      });
      root.querySelectorAll('.bgl-plan-single').forEach(function (el) {
        el.classList.toggle('is-selected', isSingleSelected);
      });

      setText('recJarsLabel', label(sz.rec.jars));
      setText('starterPrice', money(tierPrice(sz.rec)));
      if (isSub && sz.rec.subPrice != null) {
        setText('starterRefPrice', money(sz.rec.price));
        show('starter-ref-price', true);
      } else {
        show('starter-ref-price', false);
      }
      var starterSavePct = isSub && sz.rec.subPrice != null
        ? Math.round((1 - sz.rec.subPrice / sz.rec.price) * 100)
        : (sz.rec.compareAtPrice ? Math.round((1 - sz.rec.price / sz.rec.compareAtPrice) * 100) : 0);
      show('starter-save', starterSavePct > 0);
      setText('starterSaveBadge', 'Save ' + starterSavePct + '%');
      setText('starterShipLine', isSub
        ? 'Ships ' + (sz.rec.sellingPlanName || '') + ' • Cancel or pause anytime'
        : 'One-time purchase');
      setText('coverageNote', sz.rec.jars + (sz.rec.jars === 1 ? ' jar' : ' jars') + ' = your ' + sz.name.toLowerCase() + ' dog’s recommended starting supply to notice an improvement.');

      if (single) {
        setText('singlePrice', money(tierPrice(single)));
        var singleSavePct = isSub && single.subPrice != null
          ? Math.round((1 - single.subPrice / single.price) * 100)
          : (single.compareAtPrice ? Math.round((1 - single.price / single.compareAtPrice) * 100) : 0);
        show('single-save', singleSavePct > 0);
        setText('singleSaveBadge', 'Save ' + singleSavePct + '%');
        setText('singleShipLine', isSub ? 'Ships ' + (single.sellingPlanName || '') : 'One-time purchase');
      }

      show('opt-in-sub', isSub);
      show('opt-in-otp', !isSub);
      var savings = tier.price - (tier.subPrice != null ? tier.subPrice : tier.price);
      setText('savingsLine', 'Switch to a subscription to save another ' + money(savings));

      // addons
      Object.keys(data.addons).forEach(function (k) {
        var on = !!state.addons[k];
        root.querySelectorAll('[data-addon-toggle="' + k + '"]').forEach(function (btn) {
          btn.classList.toggle('is-added', on);
          var dot = btn.querySelector('.bgl-addon-toggle__dot');
          if (dot) dot.textContent = on ? '✓' : '+';
          var lbl = btn.querySelector('.bgl-addon-toggle__label');
          if (lbl) lbl.textContent = on ? 'Added' : 'Add';
        });
      });

      setText('atcLabel', 'ADD TO CART • ' + money(tierPrice(tier) + addonTotal()));
      setText('trustLine', isSub
        ? 'Secure Checkout • 180-Day Money-Back Guarantee • Cancel Anytime'
        : 'Secure Checkout • 180-Day Money-Back Guarantee');

      renderGallery(sz);
    }

    var lastGalleryKey = null;
    function renderGallery(sz) {
      var main = root.querySelector('[data-gallery-main]');
      var thumbGrid = root.querySelector('[data-thumb-grid]');
      if (!main || !thumbGrid) return;
      var imgs = (sz && sz.images && sz.images.length) ? sz.images : [null];
      if (state.slide >= imgs.length) state.slide = 0;

      var galleryKey = (sz ? sz.name : 'none') + ':' + imgs.length;
      if (galleryKey !== lastGalleryKey) {
        lastGalleryKey = galleryKey;
        main.querySelectorAll('.bgl-gallery-slide').forEach(function (el) { el.remove(); });
        thumbGrid.innerHTML = '';
        var prevBtn = main.querySelector('[data-gallery-nav="prev"]');
        imgs.forEach(function (img, i) {
          var slide = document.createElement('div');
          slide.className = 'bgl-gallery-slide';
          slide.setAttribute('data-gallery-slide', '');
          slide.innerHTML = img
            ? '<img src="' + img.url + '" alt="" loading="' + (i === 0 ? 'eager' : 'lazy') + '">'
            : '<div class="bgl-placeholder"><span class="bgl-placeholder__label">Buddy Guard product photo</span></div>';
          main.insertBefore(slide, prevBtn);

          var thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'bgl-thumb';
          thumb.setAttribute('data-gallery-thumb', '');
          thumb.setAttribute('aria-label', 'Show image ' + (i + 1));
          thumb.innerHTML = img
            ? '<img src="' + img.url + '" alt="" loading="lazy">'
            : '<div class="bgl-placeholder"></div>';
          thumb.addEventListener('click', function () { state.slide = i; render(); });
          thumbGrid.appendChild(thumb);
        });
      }

      root.querySelectorAll('[data-gallery-slide]').forEach(function (el, i) {
        el.classList.toggle('is-active', i === state.slide);
      });
      root.querySelectorAll('[data-gallery-thumb]').forEach(function (el, i) {
        el.classList.toggle('is-active', i === state.slide);
      });
    }

    // --- size / plan / mode ---
    root.querySelectorAll('.bgl-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sizeKey = btn.getAttribute('data-size');
        state.size = sizeKey;
        state.plan = 'starter';
        state.slide = 0;
        render();
      });
    });
    root.querySelectorAll('.bgl-plan[data-plan="starter"]').forEach(function (btn) {
      btn.addEventListener('click', function () { state.plan = 'starter'; render(); });
    });
    root.querySelectorAll('.bgl-plan-single').forEach(function (btn) {
      btn.addEventListener('click', function () { state.plan = 'single'; render(); });
    });
    root.querySelectorAll('[data-action="one-time"]').forEach(function (btn) {
      btn.addEventListener('click', function () { state.mode = 'otp'; render(); });
    });
    root.querySelectorAll('[data-action="subscribe"]').forEach(function (btn) {
      btn.addEventListener('click', function () { state.mode = 'sub'; render(); });
    });

    // --- addons ---
    root.querySelectorAll('[data-addon-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var k = btn.getAttribute('data-addon-toggle');
        state.addons[k] = !state.addons[k];
        render();
      });
    });

    // --- gallery ---
    root.querySelectorAll('[data-gallery-nav="prev"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var count = (currentSize() && currentSize().images || []).length || 1;
        state.slide = (state.slide + count - 1) % count;
        render();
      });
    });
    root.querySelectorAll('[data-gallery-nav="next"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var count = (currentSize() && currentSize().images || []).length || 1;
        state.slide = (state.slide + 1) % count;
        render();
      });
    });

    // swipe directly on the main gallery image (touch)
    (function initGallerySwipe() {
      var main = root.querySelector('[data-gallery-main]');
      if (!main) return;
      var startX = 0, startY = 0, tracking = false;
      main.addEventListener('touchstart', function (e) {
        if (e.target.closest('button')) return;
        var t = e.changedTouches[0];
        startX = t.clientX; startY = t.clientY; tracking = true;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var count = (currentSize() && currentSize().images || []).length || 1;
        state.slide = dx < 0 ? (state.slide + 1) % count : (state.slide + count - 1) % count;
        render();
      }, { passive: true });
    })();

    // --- FAQ accordion ---
    root.querySelectorAll('.bgl-faq-item').forEach(function (item, i) {
      var q = item.querySelector('.bgl-faq-q');
      var a = item.querySelector('.bgl-faq-a');
      if (!q || !a) return;
      var panelId = 'bgl-faq-panel-' + i;
      a.id = panelId;
      q.setAttribute('aria-expanded', 'false');
      q.setAttribute('aria-controls', panelId);
      q.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        root.querySelectorAll('.bgl-faq-item').forEach(function (other) {
          other.classList.remove('is-open');
          var otherQ = other.querySelector('.bgl-faq-q');
          var otherA = other.querySelector('.bgl-faq-a');
          if (otherA) otherA.style.maxHeight = '0px';
          if (otherQ) otherQ.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          item.classList.add('is-open');
          a.style.maxHeight = a.scrollHeight + 'px';
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // --- pilot study chart lightbox ---
    (function initLightbox() {
      var triggers = root.querySelectorAll('[data-lightbox-trigger]');
      var box = root.querySelector('[data-lightbox]');
      if (!triggers.length || !box) return;
      var closeBtn = box.querySelector('[data-lightbox-close]');
      function open() {
        box.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
      }
      function close() {
        box.classList.remove('is-open');
        document.body.style.overflow = '';
      }
      triggers.forEach(function (t) { t.addEventListener('click', open); });
      if (closeBtn) closeBtn.addEventListener('click', close);
      box.addEventListener('click', function (e) { if (e.target === box) close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && box.classList.contains('is-open')) close();
      });
    })();

    // --- add to cart ---
    root.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tier = activeTier();
        if (!tier) return;
        var items = [{ id: tier.variantId, quantity: 1 }];
        if (state.mode === 'sub' && tier.sellingPlanId) items[0].selling_plan = tier.sellingPlanId;
        Object.keys(state.addons).forEach(function (k) {
          if (state.addons[k] && data.addons[k]) items.push({ id: data.addons[k].variantId, quantity: 1 });
        });
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.textContent = 'Added ✓';
            updateCartBadge();
            // The theme's slide-in cart (Upcart) auto-opens on a /cart/add.js
            // call, but call it explicitly as a reliable fallback.
            if (window.Upcart && typeof window.Upcart.openCart === 'function') {
              window.Upcart.openCart();
            }
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = original;
            }, 2000);
          })
          .catch(function (err) {
            console.error('Buddy Guard add to cart failed', err);
            btn.disabled = false;
            btn.textContent = original;
          });
      });
    });

    // --- addon rail drag scroll (mouse only; touch/trackpad scroll natively) ---
    (function initDrag() {
      var rail = document.querySelector('[data-addon-rail]');
      if (!rail) return;
      var down = false, sx = 0, sl = 0, moved = 0;
      rail.addEventListener('pointerdown', function (e) {
        if (e.target.closest('button') || e.pointerType !== 'mouse') return;
        down = true; moved = 0; sx = e.clientX; sl = rail.scrollLeft;
        rail.classList.add('is-dragging');
        // Stop native text/image selection from hijacking the drag.
        e.preventDefault();
      });
      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        var d = e.clientX - sx;
        moved = Math.abs(d);
        if (moved > 3) { rail.setPointerCapture(e.pointerId); }
        rail.scrollLeft = sl - d;
      });
      var up = function () { down = false; rail.classList.remove('is-dragging'); };
      rail.addEventListener('pointerup', up);
      rail.addEventListener('pointercancel', up);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    })();

    // --- timeline scroll-linked progress (needs continuous position, so
    // this one stays rAF/scroll-driven rather than IntersectionObserver) ---
    (function initTimeline() {
      var stages = Array.prototype.slice.call(document.querySelectorAll('[data-tl-stage]'));
      if (!stages.length) return;
      var fill = document.querySelector('[data-tl-fill]');
      var markers = stages.map(function (el) { return el.querySelector('[data-tl-marker]'); });
      var photos = stages.map(function (el) { return el.querySelector('[data-tl-photo]'); });
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var pending = false;
      function schedule() {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; tick(); });
      }

      function tick() {
        var vh = window.innerHeight || 800;
        var cue = vh * 0.55;
        var rects = stages.map(function (el) { return el.getBoundingClientRect(); });
        var first = rects[0];
        var last = rects[rects.length - 1];
        var done = last.bottom < 0;
        var active = 0;
        rects.forEach(function (r, i) { if (r.top < cue) active = i; });
        var span = (last.top + last.height * 0.25) - first.top;
        var prog = span > 0 ? Math.min(Math.max((cue - first.top) / span, 0), 1) : 0;

        stages.forEach(function (el, i) {
          var on = done || i === active;
          el.classList.toggle('is-active', on);
          var m = markers[i];
          if (m) {
            var lit = done || i <= active;
            m.classList.toggle('is-lit', lit);
            m.classList.toggle('is-current', i === active && !done);
          }
          var ph = photos[i];
          if (ph) {
            ph.classList.toggle('is-active', on);
            ph.classList.toggle('is-past', !on && i < active);
            if (!reduceMotion) {
              var rot = ph.getAttribute('data-rot') || '0';
              ph.style.transform = on
                ? 'translateY(0) rotate(' + rot + 'deg) scale(1)'
                : 'translateY(14px) rotate(0deg) scale(.95)';
            }
          }
        });
        if (fill) fill.style.height = (done ? 100 : prog * 100) + '%';
      }

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      schedule();
    })();

    // --- sticky mobile CTA: IntersectionObserver-driven, not scroll polling ---
    (function initStickyBar() {
      var bar = document.querySelector('[data-sticky-bar]');
      var box = document.getElementById('bgl-buy-box');
      var footer = document.querySelector('.bgl-footer');
      // Variant F only: an inline "SUPPORT MY DOG" CTA sits in the early
      // desire section. Absent on every other variant, so this is a no-op
      // there — guarded below rather than scoped via CSS.
      var desireCta = document.querySelector('.bgl-desire-cta');
      if (!bar || !('IntersectionObserver' in window)) return;

      // Visible from the very top of the page (so a returning visitor can
      // tap straight into the buy box from the hero, no scrolling needed),
      // hidden only while the buy box itself, the footer, or (variant F)
      // the inline desire-section CTA is on screen — two competing
      // primary CTAs should never be stacked on top of each other.
      var boxVisible = false;
      var footerVisible = false;
      var desireCtaVisible = false;

      function update() {
        bar.classList.toggle('is-visible', !boxVisible && !footerVisible && !desireCtaVisible);
      }
      update();

      if (box) {
        new IntersectionObserver(function (entries) {
          boxVisible = entries[0].isIntersecting;
          update();
        }, { threshold: 0.15 }).observe(box);
      }
      if (footer) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          update();
        }, { threshold: 0 }).observe(footer);
      }
      if (desireCta) {
        new IntersectionObserver(function (entries) {
          desireCtaVisible = entries[0].isIntersecting;
          update();
        }, { threshold: 0.2 }).observe(desireCta);
      }
    })();

    // --- mobile sticky Add To Cart: bridges the gap between the plan
    // card and the real ATC button further down, past the add-ons ---
    (function initStickyAtc() {
      var atc = root.querySelector('[data-sticky-atc]');
      // Buy boxes with a size picker (e.g. cwr-product-details-bgl) repeat
      // the "starter" plan card once per size, hidden/shown as the size
      // selection changes — only one is ever actually on screen at a time,
      // so watch all of them and treat "visible" as any intersecting.
      var planCards = root.querySelectorAll('[data-plan="starter"]');
      // data-bgl-real-atc: fallback for buy-box forks (e.g. cwr-product-details-bgl)
      // that don't use the classic render()/BGL_DATA engine data-add-to-cart hooks into.
      var realBtn = root.querySelector('[data-add-to-cart]') || root.querySelector('[data-bgl-real-atc]');
      if (!atc || !planCards.length || !('IntersectionObserver' in window)) return;

      var visiblePlanCards = new Set();
      var realBtnVisible = false;

      function update() {
        atc.classList.toggle('is-visible', visiblePlanCards.size > 0 && !realBtnVisible);
      }

      var planObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) visiblePlanCards.add(entry.target);
          else visiblePlanCards.delete(entry.target);
        });
        update();
      }, { threshold: 0.1 });
      planCards.forEach(function (card) { planObserver.observe(card); });

      // Hide as soon as the real ATC button is approaching from below,
      // well before it's actually on screen, so the two never overlap.
      if (realBtn) {
        new IntersectionObserver(function (entries) {
          realBtnVisible = entries[0].isIntersecting;
          update();
        }, { threshold: 0, rootMargin: '0px 0px 120px 0px' }).observe(realBtn);
      }

      var btn = atc.querySelector('[data-sticky-atc-btn]');
      if (btn && realBtn) {
        btn.addEventListener('click', function () { realBtn.click(); });
      }
    })();

    // --- fix up "#" jump-links on this very long page ---
    // Content loading in below the fold (lazy images, etc.) can shift the
    // page's layout while the browser's native smooth-scroll to a same-page
    // anchor is still mid-flight, since that animation targets a fixed
    // distance computed at click time. Re-issue the scroll shortly after so
    // it lands on the target's real, current position.
    (function initAnchorScrollFix() {
      root.querySelectorAll('a[href^="#"]').forEach(function (a) {
        a.addEventListener('click', function () {
          var id = a.getAttribute('href').slice(1);
          var target = id && document.getElementById(id);
          if (!target) return;
          setTimeout(function () {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 700);
        });
      });
    })();

    render();
  }
})();
